var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5194 30H1.48066C0.662891 30 0 29.2013 0 28.216V25.7344L22 20.9177V28.216C22 29.2013 21.3371 30 20.5194 30Z",
    fill: "#429E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4913 28.2161H1.48313C0.664026 28.2161 0 27.4161 0 26.4292V4.27105C0 3.28417 0.664026 2.48413 1.48313 2.48413H20.5168C21.336 2.48413 22 3.28417 22 4.27105V21.579C22 22.0529 21.1034 22.5074 20.8252 22.8426L17.54 26.8007C17.2619 27.1359 16.8846 28.2161 16.4913 28.2161Z",
    fill: "#64AB88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.4843 28.216C16.8777 28.216 17.2549 28.0278 17.5331 27.6926L21.5656 22.8342C21.8437 22.499 22 22.0445 22 21.5706V20.8467C22 21.6553 21.456 22.3108 20.7848 22.3108H18.3139C17.6428 22.3108 17.0987 22.9662 17.0987 23.7748V26.7519C17.0987 27.5605 16.5547 28.216 15.8835 28.216H16.4843V28.216Z",
    fill: "#224735"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.79684 5.59764C2.45658 5.59764 2.1677 5.59746 1.92152 5.59746C1.17345 5.59746 0.565125 4.98914 0.565125 4.24167V3.37586C0.565125 2.88324 0.964474 2.48389 1.4571 2.48389V4.24167C1.4571 4.49737 1.66522 4.70549 1.92152 4.70549C2.1677 4.70549 3.04302 5.59764 2.79684 5.59764Z",
    fill: "#224735"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.9984 5.59764C18.9984 5.59764 18.3695 5.59746 18.1227 5.59746C17.3752 5.59746 16.7669 4.98914 16.7669 4.24167V2.48389H17.6589V4.24167C17.6589 4.49737 17.867 4.70549 18.1227 4.70549C18.3695 4.70549 18.9984 5.35146 18.9984 5.59764Z",
    fill: "#224735"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46581 2.48408V1.35621C3.46581 1.10022 3.25756 0.891972 3.00156 0.891972H2.79683C2.54083 0.891972 2.33259 1.10022 2.33259 1.35621V4.24145C2.33259 4.49744 2.54083 4.70569 2.79683 4.70569C3.04313 4.70569 3.24281 4.90537 3.24281 5.15168C3.24281 5.39798 3.04313 5.59766 2.79683 5.59766C2.049 5.59766 1.44061 4.98928 1.44061 4.24145V1.35621C1.44061 0.608384 2.049 0 2.79683 0H3.00156C3.74939 0 4.35778 0.608384 4.35778 1.35621V2.48408H3.46581Z",
    fill: "#224735"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6674 2.48408V1.35621C19.6674 1.10022 19.4592 0.891972 19.2032 0.891972H18.9984C18.7424 0.891972 18.5342 1.10022 18.5342 1.35621V4.24145C18.5342 4.49744 18.7424 4.70569 18.9984 4.70569C19.2447 4.70569 19.4444 4.90537 19.4444 5.15168C19.4444 5.39798 19.2447 5.59766 18.9984 5.59766C18.2506 5.59766 17.6422 4.98928 17.6422 4.24145V1.35621C17.6422 0.608384 18.2506 0 18.9984 0H19.2032C19.951 0 20.5594 0.608384 20.5594 1.35621V2.48408H19.6674Z",
    fill: "#224735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c6484287044908f032e3e9ce9c4a92e6.svg";
export { ForwardRef as ReactComponent };